export const CURRENT_YEAR = new Date().getFullYear();

export const MIN_DATE_OF_BIRTH = new Date('01-01-1901');

// FDA 3D GP clearance requires patients to be at least 22 years old
// as wisdom teeth typically finish developing by this age
export const MINIMUM_PATIENT_AGE_FDA = 22;

// FDA 2.0 clinical environment accepts patients from 3 years old
export const MINIMUM_PATIENT_AGE_FDA_VERSION2 = 3;

export const getMaxDateOfBirthForMinAge = (minAge: number): Date => {
  const today = new Date();
  return new Date(
    today.getFullYear() - minAge,
    today.getMonth(),
    today.getDate(),
  );
};

export const getPickerDateFromISO = (ISOdate: string): Date =>
  new Date(ISOdate);
